export default __webpack_public_path__ + "static/media/mustarddreams.838508d3.png";